import { PaginationParams } from 'util/types/pagination';
import { AxiosInstance } from 'axios';
import { SearchResponse, SearchSchoolsResponse } from 'services/api';
import { BaseApi } from 'services/api/base-api';
import { ApiResult } from 'services/api/result.type';

export class SearchApi extends BaseApi {
  public constructor(protected readonly api: AxiosInstance) {
    super();

    this.searchSchools = this.searchSchools.bind(this);
    this.search = this.search.bind(this);
  }

  public async searchSchools(query: string): ApiResult<SearchSchoolsResponse> {
    return await this.get<SearchSchoolsResponse>('/search/schools', {
      params: {
        q: query,
      },
    });
  }

  public async search(
    query: string,
    { page = 1, pageSize = 20 }: PaginationParams = {},
  ): ApiResult<SearchResponse> {
    return await this.get<SearchResponse>('/search', {
      params: {
        q: query,
        page,
        pageSize,
      },
    });
  }
}
